import { MasterRepo } from './../../common/repositories/masterRepo.service';
//import { CookieService } from "angular2-cookie/core";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';
import {
  FormGroup,
  AbstractControl,
  FormBuilder,
  Validators,
} from '@angular/forms';

import 'style-loader!./login.scss';
import { Router, ActivatedRoute } from '@angular/router';
//import { AuthService } from "../../common/services/permission";
import { LoginService } from './loginService.service';

import { ModalDirective } from 'ngx-bootstrap/modal';
import { CookieService, SameSite } from 'ngx-cookie-service';
import { UUID } from 'angular2-uuid';
export var var1: string;
//import {getmac} from 'getmac';
@Component({
  selector: 'login',
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  providers: [],
})
export class Login implements OnInit {
  @Output('signedIn') signedIn = new EventEmitter();
  @Input('toUrl')
  set toUrl(value: string) {
    this._toUrl = value;
    console.log({ toUrl: value });
  }
  @Output() filterData = new EventEmitter();
  private _toUrl: string = '';
  public form!: FormGroup;
  public email!: AbstractControl;
  public password!: AbstractControl;
  public submitted: boolean = false;
  returnUrl: string = '';
  signOut: any;
  @ViewChild('childModal') childModal!: ModalDirective;
  DialogMessage: string = ' ';
  public SendMail = true;
  SearchUser = true;
  securityCode = true;
  newPassword = true;
  cookiebox: boolean = false;
  sameSite: SameSite;
  constructor(
    fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    public loginService: LoginService,
    private cookie: CookieService
  ) {
    try {
      this.form = fb.group({
        email: [
          '',
          Validators.compose([Validators.required, Validators.minLength(2)]),
        ],
        password: [
          '',
          Validators.compose([Validators.required, Validators.minLength(4)]),
        ],
      });

      this.email = this.form.controls['email'];
      this.password = this.form.controls['password'];
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  ngOnInit() {
    try {
      // console.log("login");
      let logout = this.route.snapshot.params['logout'];
      // console.log(logout);
      this.returnUrl = this.route.snapshot.params['returnUrl'] || '/';
      // console.log({ retUrl1: this.returnUrl });

      if (logout) {
        //   console.log("log out");
        this.onLogOut();
      }
      //console.log(this.returnUrl);
    } catch (ex) {
      console.log({ loginOnintError: ex });
      //alert(ex);
    }
    this.SendMail = false;
    this.SearchUser = false;
    this.loginService.sendMail = false;
    this.securityCode = false;
    this.loginService.securityCode = false;
    this.loginService.newPassword = false;
    this.loginService.searchUser = false;
    this.loginService.loginpage = true;
    this.check();
  }
  public onSubmit(values: Object): void {
    try {
      var chk = this.check();
      if (chk == false) {
        alert('Cookie should be allowed in order to login');
        return;
      }
      this.submitted = true;
      console.log({ valid: this.form.valid, url: this.returnUrl });
      if (this.form.valid) {
        // console.log(this.email.value, this.password.value);
        this.loginService
          .login(this.email.value, this.password.value)
          .subscribe(
            (data: any) => {
              console.log(data, 'dattaaaa');
              this.router.navigate(['pages/dashboard']);
              console.log(data, 'data');
              // console.log("@@@@" + "/pages/dashboard");
              console.log('lofff');
              if (this._toUrl != '') {
                //  console.log("Test1")
                this.signedIn.emit('logged In');
              } else {
                if (this.returnUrl == '/') console.log('test2');
                //  var cookie = this._cookieService.get("imsposcookie");
                //    console.log(cookie);
                // if (cookie != null) {
                //   this.returnUrl = "/pages/dashboard"
                //   this.router.navigate([this.returnUrl]);
                //   console.log("Cookies != null")
                //   var J = JSON.parse(cookie);
                //   return J;
                // }
                // else {
                //   this.DialogMessage = "Cookies not found. Please register this terminal"
                //   this.childModal.show();
                //   setTimeout(() => {
                //     this.childModal.hide();
                //   }, 4000)
                //   this.router.navigate(["/pages/terminal"]);
                // }
              }
            },
            (error: any) => {
              console.log(error);
              if (error._body == 'Invalid credentials') {
                // alert('Invalid username or password');
                return;
              }
              alert(JSON.stringify(error.error));
              this.submitted = false;
            }
          );
        // your code goes here
        // console.log(values);
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  hideChildModal() {
    this.childModal.hide();
  }
  public onLogOut(): void {
    this.loginService.logout();
  }
  ForgetPassword() {
    this.loginService.searchUser = true;
    this.loginService.loginpage = false;
  }

  check(): boolean {
    //const checking = this.cookie.check('data');
    const checking = window.localStorage.getItem('data');
    if (checking) {
      this.cookiebox = false;
    } else {
      this.cookiebox = true;
    }
    return checking != null;
  }
  decline() {
    this.cookiebox = false;
  }

  allow() {
    var guid = UUID.UUID();
    window.localStorage.setItem('data', guid);
    this.cookie.set('data', guid, 1, '/', '', true);
    this.cookiebox = false;
  }

  delete() {
    window.localStorage.removeItem('data');
    this.cookie.delete('data');
  }
}
